import React from 'react'
import { Pages } from './routes/routesState'
import { CurrentPage } from '../utils/routes.shared'
import { Page } from './cmsPage/cmsPageState'

export const RootLayout = (props: {
  children: React.ReactNode
  kind: CurrentPage<Pages>['kind'] | Page['kind'] | ''
  inCentrum: boolean
  /** Rendered inside a third-party iframe (?embed=1), without site chrome. */
  embed?: boolean
}) => (
  <main
    id="a11y-main"
    className={`main main--${props.kind}
  ${props.inCentrum ? ' main--centra' : ''}
  ${props.embed ? ' main--embed' : ''}
  ${props.kind === 'friend' || props.kind === 'friendHome' ? ' main--vrienden' : ''}`}
  >
    <article className="page">{props.children}</article>
  </main>
)
